import { Children, cloneElement, isValidElement } from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

import { IBudgetRequestTimeLineStepProps } from './BudgetRequestTimeLineStep';

interface IProps {
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

export const BudgetRequestTimeLine = ({ children, sx }: IProps) => {
    const steps = Children.toArray(children).filter(
        isValidElement<IBudgetRequestTimeLineStepProps>
    );

    return (
        <Box sx={sx}>
            {steps.map((step, index) =>
                // The timeline owns the connector: every step but the last one
                // draws a line down to the next.
                cloneElement(step, {
                    showConnector: index < steps.length - 1,
                })
            )}
        </Box>
    );
};
